var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$context.is.edu)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('billing.common.learn_more_about_edu'))},on:{"click":function($event){return _vm.clickHandler($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }